"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DynamicIntroScreen = _interopRequireDefault(require("../DynamicIntroScreen/DynamicIntroScreen"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const QuestionWithIntroScreen = _ref => {
  let {
    question
  } = _ref;
  const {
    messageTitle,
    messageText,
    actionBtnText
  } = question;
  return /*#__PURE__*/_react.default.createElement(_DynamicIntroScreen.default, {
    messageTitle: messageTitle,
    messageText: messageText,
    actionBtnText: actionBtnText
  });
};
var _default = QuestionWithIntroScreen;
exports.default = _default;
QuestionWithIntroScreen.propTypes = {
  question: _propTypes.default.shape({
    messageTitle: _propTypes.default.string,
    messageText: _propTypes.default.string,
    actionBtnText: _propTypes.default.string
  }).isRequired
};